export const COURSE_STATUS = {
  DRAFT: 'Draft',
  PUBLISHED: 'Published',
} as const;

export type CourseStatus = (typeof COURSE_STATUS)[keyof typeof COURSE_STATUS];
